import { sessionRequest } from "./auth.js";

const CMS_API = "./api/cms.php";

export async function fetchRemoteCms() {
  const res = await fetch(CMS_API, { cache: "no-store" });
  if (!res.ok) {
    throw new Error(`CMS fetch failed (${res.status})`);
  }
  const data = await res.json();
  return data && typeof data === "object" ? data : {};
}

export async function pushRemoteCms(data) {
  await sessionRequest(CMS_API, { data });
}

export function hasRemoteCmsContent(data) {
  if (!data || typeof data !== "object") return false;
  return Boolean(
    data.menu ||
      data.branches ||
      data.branchList?.length ||
      data.gallery?.length ||
      data.heroSlides?.length ||
      data.storyParagraphs?.length ||
      data.text ||
      data.images ||
      data.links
  );
}
